export const outgoingDocumentTypeListPathName = 'outgoing-document-type';
export const followUpRuleListPathName = 'follow-up-rule';
export const taskConfigurationListPathName = 'task-configuration';
export const guideLinkListPathName = 'guide-link';
export const standardPhraseListPathName = 'standard-phrase';
